export const CLOCK_ADDRESS = '0x0000000000000000000000000000000000000000000000000000000000000006'
export const GAS_TYPE_ARG = '0x2::sui::SUI'
export const GAS_TYPE_ARG_LONG = '0x0000000000000000000000000000000000000000000000000000000000000002::sui::SUI'
export const MMT_ORACLE_PACKAGE_ID = process.env.MMT_ORACLE_PACKAGE_ID || '0x45fe3ef1ed2d9b444b8041a84e426242ad129483bf56000cdd514b8065967f4d'
export const ORACLE_ADMIN_CAP_ID = process.env.ORACLE_ADMIN_CAP_ID || '0xf5ca46bf4d4c087766118f143dea81d0ef3af9c2704635ece9d3af18f22aacb8'
export const REGISTRY_ADMIN_CAP_ID = process.env.REGISTRY_ADMIN_CAP_ID || '0x77659bd055091b9d3d193263af964fbd0c47d75601a247f6e4777f70cf82450f'
export const COIN_DECIMALS_REGISTRY = process.env.COIN_DECIMALS_REGISTRY || '0x04a645616e229f986b0b4c15def3ef46c4d84ad51d1d6419d567498de0dba564'
export const SET_PRICE_CAP_REGISTRY = process.env.SET_PRICE_CAP_REGISTRY || '0xd088d1eaf09dfda03c989acf3063fd0e3e14432a2d21bf9fd2be30bf76373bfd'
export const MMT_ORACLE_ID = process.env.MMT_ORACLE_ID || '0x6cc485157712b67d3bbc71110947084aad0d23d7661add04e13038cfa765e80a'
export const VAULT_PACKAGE_ID = process.env.VAULT_PACKAGE_ID || '0x8e5c2564d9e8a6d2687eb6f1d7322fd0ed7c66d3bd57c9664d74814f148a314e'
export const VAULT_VERSION_ID = process.env.VAULT_VERSION_ID || '0xef1aff44bb19bb1d0908b1fee334b680df8f1175e31e49a821ac7942913efd09'
export const MMT_CLMM_VERSION_ID = process.env.MMT_CLMM_VERSION_ID || '0x2375a0b1ec12010aaea3b2545acfa2ad34cfbba03ce4b59f4c39e1e25eed1b2a'
export const VaultsDepositModule = 'deposit'
export const VAULTS_WITHDRAW_MODULE = 'withdraw'
export const PRICE_ADAPTER_PACKAGE_ID = process.env.PRICE_ADAPTER_PACKAGE_ID || '0x1bf70849bc2b14361b30c1b10809d9b592224de25114798dca4a5891e011426a'
export const REGISTRY_ID = process.env.REGISTRY_ID || '0x6f8c395de3f250e08c01a25500c185d74cb182002d76750189c7e20a514befa8'
export const PRICE_ADAPTER_ADMIN_CAP = process.env.PRICE_ADAPTER_ADMIN_CAP || '0x9eec84b9c46c4087fe2f2261084092dd9835a9c81dfe6ff711beb306385d3a59'
export const VAULT_ADMIN_CAP = process.env.VAULT_ADMIN_CAP || '0xb3320d9cd09d23f0c7be41fcbe88ef6da9613ae097bd53d510b3ad91bad62378'
export const VAULT_ACL = process.env.VAULT_ACL || '0x77d3b63065b24fff2c934853b9670c848680712977a66c4494e630d76ff097d5'
export const ROUTER_ACL = process.env.ROUTER_ACL || '0x253fb8c10c2f7be045f28b67cf72cbb58f6a21cc0cf38dd9d213d02468d9e829'
export const MMT_ROUTER_PACKAGE_ID = process.env.MMT_ROUTER_PACKAGE_ID || '0x5f9b325644ed096907becd7349a901623dbf604f7217fd8d521a06072aa32602'
export const PYTH_STATE_ID = process.env.PYTH_STATE_ID || '0x1f9310238ee9298fb703c3419030b35b22bb1cc37113e3bb5007c99aec79e5b8'
export const NEMO_API_URL = process.env.NEMO_API_URL || 'https://api.nemoprotocol.com/api/v1'
export const MMT_CLMM_PACKAGE_ID = process.env.MMT_CLMM_PACKAGE_ID || '0xcf60a40f45d46fc1e828871a647c1e25a0915dec860d2662eb10fdb382c3c1d1'
export const PYTH_ORACLE_MAP: Record<string, {
  priceInfoObjectId: string
}> = {
  '0x2::sui::SUI': {
    priceInfoObjectId: '0x801dbc2f0053d34734814b2d6df491ce7807a725fe9a01ad74a07e9c51396c37'
  },
  '0x0000000000000000000000000000000000000000000000000000000000000002::sui::SUI': {
    priceInfoObjectId: '0x801dbc2f0053d34734814b2d6df491ce7807a725fe9a01ad74a07e9c51396c37'
  },
  '0x375f70cf2ae4c00bf37117d0c85a2c71545e6ee05c4a5c7d282cd66a4504b068::usdt::USDT': {
    priceInfoObjectId: '0x985e3db9f93f76ee8bace7c3dd5cc676a096accd5d9e09e9ae0fb6e492b14572'
  },
  '0xdba34672e30cb065b1f93e3ab55318768fd6fef66c15942c9f7cb846e2f900e7::usdc::USDC': {
    priceInfoObjectId: '0x5dec622733a204ca27f5a90d8c2fad453cc6665186fd5dff13a83d0b6c9027ab'
  },
  '0x2b6602099970374cf58a2a1b9d96f005fccceb81e92eb059873baf420eb6c717::x_sui::X_SUI': {
    priceInfoObjectId: '0x801dbc2f0053d34734814b2d6df491ce7807a725fe9a01ad74a07e9c51396c37'
  },
  '0x876a4b7bce8aeaef60464c11f4026903e9afacab79b9b142686158aa86560b50::xbtc::XBTC': {
    priceInfoObjectId: '0x9a62b4863bdeaabdc9500fce769cf7e72d5585eeb28a6d26e4cafadc13f76ab2'
  },
  '0xaafb102dd0902f5055cadecd687fb5b71ca82ef0e0285d90afde828ec58ca96b::btc::BTC': {
    priceInfoObjectId: '0x9a62b4863bdeaabdc9500fce769cf7e72d5585eeb28a6d26e4cafadc13f76ab2'
  },
  '0x3e8e9423d80e1774a7ca128fccd8bf5f1f7753be658c5e645929037f7c819040::lbtc::LBTC': {
    priceInfoObjectId: '0x9a62b4863bdeaabdc9500fce769cf7e72d5585eeb28a6d26e4cafadc13f76ab2'
  }
}
export const IS_MMT_ORACLE_PRICE_SUI_PAIR: string[] = [
  '0x2b6602099970374cf58a2a1b9d96f005fccceb81e92eb059873baf420eb6c717::x_sui::X_SUI',
  '0x876a4b7bce8aeaef60464c11f4026903e9afacab79b9b142686158aa86560b50::xbtc::XBTC',
  '0x3e8e9423d80e1774a7ca128fccd8bf5f1f7753be658c5e645929037f7c819040::lbtc::LBTC'
]
export const VAULTS_CONFIG = {
  config: {
    haedal: {
      package_id: '0xbde4ba4c2e274a60ce15c1cfff9e5c42e41654ac8b6d906a57efa4bd3c29f47d',
      published_at: '0xaabf0856070391df81fad9240049d69c5a51c3d376cc0885eeedd516526cc79b',
      version: 1,
      config: {
        staking_id: '0x47b224762220393057ebf4f70501b6e657c3e56684737568439a04f80849b2ca',
        coin_type: '0xbde4ba4c2e274a60ce15c1cfff9e5c42e41654ac8b6d906a57efa4bd3c29f47d::hasui::HASUI',
      },
    },
    volo: {
      package_id: '0x549e8b69270defbfafd4f94e17ec44cdbdd99820b33bda2278dea3b9a32d3f55',
      published_at: '0x549e8b69270defbfafd4f94e17ec44cdbdd99820b33bda2278dea3b9a32d3f55',
      version: 1,
      config: {
        native_pool: '0x7fa2faa111b8c65bea48a23049bfd81ca8f971a262d981dcd9a17c3825cb5baf',
        vsui_metadata: '0x680cd26af32b2bde8d3361e804c53ec1d1cfe24c7f039eb7f549e8dfde389a60',
        coin_type: '0x549e8b69270defbfafd4f94e17ec44cdbdd99820b33bda2278dea3b9a32d3f55::cert::CERT',
      },
    },
    aftermath: {
      package_id: '0x7f6ce7ade63857c4fd16ef7783fed2dfc4d7fb7e40615abdb653030b76aef0c6',
      published_at: '0x7f6ce7ade63857c4fd16ef7783fed2dfc4d7fb7e40615abdb653030b76aef0c6',
      version: 1,
      config: {
        staked_sui_vault: '0x2f8f6d5da7f13ea37daa397724280483ed062769813b6f31e9788e59cc88994d',
        referral_vault: '0x4ce9a19b594599536c53edb25d22532f82f18038dc8ef618afd00fbbfb9845ef',
        safe: '0xeb685899830dd5837b47007809c76d91a098d52aabbf61e8ac467c59e5cc4610',
        validator_address: '0xd30018ec3f5ff1a3c75656abf927a87d7f0529e6dc89c7ddd1bd27ecb05e3db2',
        coin_type: '0xf325ce1300e8dac124071d3152c5c5ee6174914f8bc2161e88329cf579246efc::afsui::AFSUI',
      },
    },
  },
}